import Repository from '../Repository'

export default {
  // Legacy methods (keep for backward compatibility)
  getServiceTypeByServiceId: (payload) => {
    return Repository.get(`/services/service_type/${payload.id}`)
  },
  getMenuByServiceTypeId: (payload) => {
    return Repository.get(`/services/menu/${payload.id}`)
  },
  getOptionByServiceTypeId: (payload) => {
    return Repository.get(`/services/option/${payload.id}`)
  },
  getTimeBlocks: () => {
    return Repository.get(`admin/time-blocks`)
  },

  // Category/Services CRUD methods
  getServices: (payload) => {
    return Repository.get('admin/services', payload)
  },
  getService: (id) => {
    return Repository.get(`admin/services/${id}`)
  },
  createService: (payload) => {
    return Repository.post('admin/services', payload)
  },
  updateService: (id, payload) => {
    return Repository.put(`admin/services/${id}`, payload)
  },
  deleteService: (id) => {
    return Repository.delete(`admin/services/${id}`)
  },
}
